export default {
	methodLastReviewed: 'Meede kontrollitud',
	reviewMethodsInfo:
		'Rakendatud meetmeid tuleb kontrollida vähemalt korra aastas. {count} meetmel on lähiajal täitumas aasta nende viimasest kontrollist. Kontrollige antud meetmeid vajutades nupul “Vaatan meetmeid”. Meetmeid saab kontrollida ühe kaupa meetmete vaatel või kinnitada peale kontrolli “Kinnita” nupuga kõik meetmed.',
	viewMethods: 'Vaatan meetmeid',
	methodsReviewed: '{count} meedet kontrollitud.',
}
